import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Cards } from '@sorare/core/src/assets/icons/Cards';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { LabelS } from '@sorare/core/src/atoms/typography';
import { Captain } from '@sorare/core/src/components/so5/Captain';

import type { CardsLeft_so5Lineup } from './__generated__/index.graphql.ts';

const NoWrapLabelS = styled(LabelS)`
  white-space: nowrap;
`;
const PlayerLeft = styled(Horizontal).attrs({ gap: 0.5 })`
  align-self: flex-start;
  padding-top: var(--half-unit);
`;

type Props = { so5Lineup?: CardsLeft_so5Lineup };
export const CardsLeft = ({ so5Lineup }: Props) => {
  const { scheduledSo5AppearancesCount, scheduledCaptainSo5Appearance } =
    so5Lineup || {};

  if (!scheduledSo5AppearancesCount) {
    return null;
  }

  return (
    <PlayerLeft>
      {!!scheduledCaptainSo5Appearance && <Captain active />}
      <Cards />
      <NoWrapLabelS color="var(--c-nd-600)">
        <FormattedMessage
          id="CumulativeRanking.cardsLeft"
          defaultMessage="{cardsLeft, plural, =1 {# left} other {# left}}"
          values={{ cardsLeft: scheduledSo5AppearancesCount }}
        />
      </NoWrapLabelS>
    </PlayerLeft>
  );
};

CardsLeft.fragments = {
  so5Lineup: gql`
    fragment CardsLeft_so5Lineup on So5Lineup {
      id
      scheduledSo5AppearancesCount
      scheduledCaptainSo5Appearance
    }
  ` as TypedDocumentNode<CardsLeft_so5Lineup>,
};
